// extracted by mini-css-extract-plugin
module.exports = {"author":"Author_author__vUnQc","wrapper":"Author_wrapper__tj8Jf"};